module.exports = __webpack_public_path__ + "img/scratch.dd116d6c.png";